import { render, staticRenderFns } from "./ForbiddenMap.vue?vue&type=template&id=139a263a&scoped=true"
import script from "./ForbiddenMap.vue?vue&type=script&lang=js"
export * from "./ForbiddenMap.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenMap.vue?vue&type=style&index=0&id=139a263a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a263a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('139a263a')) {
      api.createRecord('139a263a', component.options)
    } else {
      api.reload('139a263a', component.options)
    }
    module.hot.accept("./ForbiddenMap.vue?vue&type=template&id=139a263a&scoped=true", function () {
      api.rerender('139a263a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forbidden/ForbiddenMap.vue"
export default component.exports